const ToastStrings = {
  defaultErrorTitle: 'Error',
  defaultErrorMessage: 'An unknown error occurred during the last action. Please try again.',
}

export default ToastStrings
